import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { motion, AnimatePresence } from 'framer-motion';
import SortableTask from './SortableTask';

const COLUMN_ICONS = {
  backlog: '📋',
  inProgress: '⚡',
  inReview: '👀',
  completed: '✅'
};

const Column = ({ id, title, tasks = [], onTaskClick }) => {
  const { setNodeRef, isOver } = useDroppable({ id });
  const { setNodeRef: setTrashRef, isOver: isOverTrash } = useDroppable({
    id: `${id}-trash`,
    data: {
      isTrash: true,
      columnId: id
    }
  });

  return (
    <div className="kanban-column">
      <h3 className="column-title">
        <span>{COLUMN_ICONS[id]}</span>
        {title}
      </h3>
      <div
        ref={setNodeRef}
        className={`task-list ${isOver ? 'dragging-over' : ''}`}
      >
        <SortableContext
          id={id}
          items={tasks.map(task => task.id)}
          strategy={verticalListSortingStrategy}
        >
          <AnimatePresence>
            {tasks.map((task) => (
              <SortableTask
                key={task.id}
                id={task.id}
                task={task}
                onClick={() => onTaskClick(task)}
              />
            ))}
          </AnimatePresence>
        </SortableContext>
        
        <div 
          ref={setTrashRef}
          className={`trash-zone ${isOverTrash ? 'dragging-over' : ''}`}
        >
          <span className="trash-icon">🗑️</span>
          <span className="trash-text">Drop to delete</span>
        </div>
      </div>
    </div>
  );
};

export default Column; 